import { __awaiter } from '../../../_virtual/_tslib.js';
import { isFunction } from '@dynamic-labs/utils';

const applyJsonRpcSignerGates = (jsonRpcSigner, walletUiUtils, provider) => {
    const originalSignMessage = jsonRpcSigner.signMessage;
    const originalSendUncheckedTransaction = jsonRpcSigner.sendUncheckedTransaction;
    if (isFunction(originalSignMessage)) {
        Object.assign(jsonRpcSigner, {
            signMessage: (message) => __awaiter(void 0, void 0, void 0, function* () {
                return walletUiUtils.signMessage({
                    handler: originalSignMessage.bind(jsonRpcSigner),
                    message,
                });
            }),
        });
    }
    if (isFunction(originalSendUncheckedTransaction)) {
        Object.assign(jsonRpcSigner, {
            sendUncheckedTransaction: (transaction) => __awaiter(void 0, void 0, void 0, function* () {
                return walletUiUtils.sendTransaction({
                    handler: originalSendUncheckedTransaction.bind(jsonRpcSigner),
                    provider,
                    transaction,
                });
            }),
        });
    }
};
const assignConfirmationScreenToIntermediaryMethods = (parent, walletUiUtils, provider) => {
    const methods = ['getSigner', 'getUncheckedSigner', 'connectUnchecked'];
    methods.forEach((methodName) => {
        const method = parent[methodName];
        if (!isFunction(method)) {
            return;
        }
        Object.assign(parent, {
            [methodName]: (...args) => {
                const result = method.bind(parent)(...args);
                if (typeof result === 'object' && result !== null) {
                    assignConfirmationScreenToIntermediaryMethods(result, walletUiUtils, provider);
                    applyJsonRpcSignerGates(result, walletUiUtils, provider);
                }
                return result;
            },
        });
    });
};
const assignConfirmationScreenToProvider = (provider, walletUiUtils) => assignConfirmationScreenToIntermediaryMethods(provider, walletUiUtils, provider);

export { assignConfirmationScreenToProvider };
